import { SoundByte } from "../enum/sounds";
import { Input, KeyCode } from "../lib/Input";
import { Time } from "../lib/Time";
import Vector2 from "../math/Vector2";
import { SPWeapOptions, WeapOptions } from "../type/WeapOptions";
import Color from "../util/Color";
import SoundManager from "./SoundManager";
import SPBogey from "./SPBogey";
import SPBullet from "./SPBullet";
import SmartBogey from "./SPEnemies/SmartBogey";
import SPGameManager from "./SPGameManager";
import SPPlayer from "./SPPlayer";
import SPTrail from "./SPTrail";

export default class SPGun {
    protected fireTimer: number = 0;
    reloadTimer: number = 0;

    player: SPPlayer|SPBogey;
    fireRate: number;
    magSize: number;
    bullets: number;
    damage: number;
    bulletSpeed: number;
    maxEnemiesHit: number;
    isOvercharged = false;

    isReloading = false;
    reloadTime: number;

    mouseTrigger: 0|1|2|undefined;
    keyTrigger: KeyCode|undefined;

    arcBlaster = false;

    get isPlayerGun() {
        return this.player instanceof SPPlayer ? true : false;
    }

    constructor(player: SPPlayer|SPBogey, options: SPWeapOptions) {
        this.player = player;
        this.fireRate = options.fireRate;
        this.magSize = options.magSize;
        this.bullets = this.magSize;
        this.reloadTime = options.reloadTime;
        this.mouseTrigger = options.mouseTrigger;
        this.keyTrigger = options.keyTrigger;
        this.damage = options.damage;
        this.bulletSpeed = options.bulletSpeed;
        this.maxEnemiesHit = options.maxEnemiesHit;
    }

    Reload() {
        if (this.bullets === this.magSize || this.isReloading) return;
        this.isReloading = true;
        this.reloadTimer = 0;
    }

    onShootOverCharged() {
        const [, bullet] = this.player.engine.NewGameObjectWithScript<SPBullet>(SPBullet, {
            position: this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 3)),
            initialValues: {
                velocity: this.player.velocity.add(this.player.transform.forward.scale(900)),
                damage: 10,
                maxEnemiesHit: 3
            }
        });

        const trail: SPTrail = bullet.gameObject.AddScript(SPTrail);
        trail.color = new Color(80,255,80);

        this.isOvercharged = false;
        SPGameManager.Singleton.crosshairSize = 4;
    }

    onShoot() {
        this.player.engine.NewGameObjectWithScript(SPBullet, {
            position: this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 3)),
            initialValues: {
                velocity: this.player.velocity.add(this.player.transform.forward.scale(this.bulletSpeed)),
                damage: this.damage,
                maxEnemiesHit: this.maxEnemiesHit,
                isPlayerBullet: this.player instanceof SPPlayer || (this.player instanceof SmartBogey && this.player.isFriendly) ? true : false,
                arcBlaster: this.arcBlaster,
                owner: this.player
            }
        });
    }

    Shoot() {
        if (this.bullets === 0 || this.isReloading || this.fireTimer > 0) return;

        this.bullets--;

        if (this.isOvercharged) {
            this.onShootOverCharged();
        } else {
            this.onShoot();
            SoundManager.Singleton.PlaySound(SoundByte.FireGun);
        }

        this.fireTimer = 1/this.fireRate;

        if (this.bullets === 0) {
            this.Reload();
        }
    }

    Update() {
        if (this.player.isDead) return;

        if (this.fireTimer > 0) {
            this.fireTimer -= Time.deltaTime;

            if (this.fireTimer <= 0) this.fireTimer = 0;
        }

        if (this.isReloading) {
            this.reloadTimer += Time.deltaTime;

            if (this.reloadTimer >= this.reloadTime) {
                this.isReloading = false;
                this.bullets = this.magSize;
            }
        }

        if (this.isPlayerGun) {
            if (this.mouseTrigger != undefined && Input.GetMouseButton(this.mouseTrigger)) {
                this.Shoot();
            }
    
            if (Input.GetKeyDown(KeyCode.KeyR)) {
                this.Reload();
            }
        }
    }

    Draw(yOffset: number) {
        const ctx = this.player.ctx;
        const engine = this.player.engine;

        if (this.isOvercharged) {
            ctx.strokeStyle = '#ffffff55';
            ctx.lineWidth = 2;
            const pos1 = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 3));
            const pos2 = pos1.add(this.player.velocity.add(this.player.transform.forward.scale(900)));
            this.player.engine.Line(pos1, pos2);
        }

        ctx.fillStyle = '#ffffff55';
        engine.FillRect(this.player.transform.position.add(new Vector2(-25, this.player.size + yOffset)), new Vector2(50, 4));

        if (this.isReloading) {
            ctx.fillStyle = '#ffff80';
            engine.FillRect(this.player.transform.position.add(new Vector2(-25, this.player.size + yOffset)), new Vector2(50 * (this.reloadTimer/this.reloadTime), 4));
        } else {
            ctx.fillStyle = '#ffffff';
            engine.FillRect(this.player.transform.position.add(new Vector2(-25, this.player.size + yOffset)), new Vector2(50 * (this.bullets/this.magSize), 4));
        }
    }

}